import React from "react";
import { Styles } from "./styles";
import i18next, { t } from "i18next";
import Loader from "../../../../common/loader/Loader";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useMediaQuery } from "../../../../../helpers/useMediaQuery";

const HeaderFloatingCardAfterPayment = ({
  isLoading,
  courseImg,
  courseName,
  courseUrl,
  // courseProgress,
}) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const wordLength = isMobile ? 22 : 25;

  return (
    <Styles courseImg={courseImg}>
      <div className="cont">
        <div className="floating-card">
          {isLoading ? (
            <Loader height={"200px"} paddingTop={"60px"} />
          ) : (
            <div className="data">
              <Link
                to={`course-details/${courseUrl}`}
                className="title text-bold"
              >
                {Resource?.continue_your_education
                  ? Resource?.continue_your_education
                  : t("home.header.continue_your_education")}
              </Link>

              <div className="course-main-data">
                {courseImg && (
                  <div className="course-img">
                    <img src={courseImg} alt="course" />
                  </div>
                )}
                <div className="course-data">
                  {/* <div className="data-header">
                  <Link to={`course-details/${courseUrl}`} className="title">
                    {Resource?.continue_your_education
                      ? Resource?.continue_your_education
                      : t("home.header.continue_your_education")}
                  </Link>
                  <Link to={`profile?activeKey=courses`} className="courses">
                    {Resource?.my_courses
                      ? Resource?.my_courses
                      : t("navbar.my_courses")}
                  </Link>
                </div> */}
                  <div className="course-name">
                    <div className="name">
                      {courseName?.length > wordLength ? (
                        <>
                          {courseName.substring(0, wordLength)}
                          ...
                        </>
                      ) : (
                        courseName
                      )}
                    </div>
                    <Link to={`course-details/${courseUrl}`} className="course">
                      <i
                        className="fa-solid fa-chevron-left"
                        style={
                          i18next.language == "ar"
                            ? { transform: "rotate(0deg)" }
                            : { transform: "rotate(180deg)" }
                        }
                      ></i>
                    </Link>
                  </div>
                  {/* <div className="course-progress">
                <div className="progress-par">
                  <div
                    className="progress-par-fill"
                    style={{ width: `${courseProgress}%` }}
                  ></div>
                </div>
                <div className="progress-percent">{courseProgress}%</div>
              </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Styles>
  );
};

export default HeaderFloatingCardAfterPayment;
